import type { ExperimentalQueries } from '../__types__/ExperimentalQueries'; //eslint-disable-line no-restricted-imports
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalAutomationRuleConnections: ExperimentalQueries['experimentalAutomationRuleConnections'] =
	(_, { ruleId, cloudId, automationStack, spaceId }, { network }) => {
		return fetchJSON(
			network,
			`/gateway/api/automation/internal-api/confluence/${cloudId}/${automationStack}/rest/${spaceId}/connections?ruleId=${ruleId}`,
			{
				method: 'GET',
				credentials: 'include',
				headers: {
					'Content-Type': MediaType.JSON,
				},
			},
		).then((response) => {
			const connections = response.map((connection: any) => {
				let targetConfig;

				if (connection.targetConfigJson) {
					targetConfig = JSON.parse(connection.targetConfigJson);
				}

				return {
					id: connection.id,
					targetConfigJson: {
						...targetConfig,
					},
					connectionTargetKey: connection.connectionTargetKey,
					accountId: connection.accountId,
					container: {
						...connection.container,
					},
				};
			});

			return connections;
		});
	};
